module.exports = __webpack_public_path__ + "img/ic_area_wh.d89cc424.svg";